export default __webpack_public_path__ + "static/media/2397.66064375.png";